import { render, staticRenderFns } from "./CollectionShow.vue?vue&type=template&id=d94c8884&"
import script from "./CollectionShow.vue?vue&type=script&lang=js&"
export * from "./CollectionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports